import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    isLoggedIn: false,
    user: {},
  },
  reducers: {
    userlogin(state, action) {
      state.isLoggedIn = true;
      state.user = action.payload;
    },
    userlogout(state) {
      state.isLoggedIn = false;
      state.user = {};
    },
    updateUserField(state, action) {
      const updatedFields = action.payload;

      // Check if nested userData exists
      if (
        state.user?.data?.body?.data?.userData
      ) {
        Object.keys(updatedFields).forEach((key) => {
          if (key in state.user.data.body.data.userData) {
            state.user.data.body.data.userData[key] = updatedFields[key];
          }
        });
      }
    }
  },
});

export const { userlogin, userlogout, updateUserField } = loginSlice.actions;
export default loginSlice.reducer;
